import moment from 'moment';
import {getI18n} from 'react-i18next';

export const formatDate = (date) => {
  if (!date) return '';

  const potentialDate = moment(date, ['YYYY-MM-DD', 'YYYY-M-D', 'DD-MM-YYYY'], true);
  if (potentialDate.isValid()) return potentialDate.format('DD-MM-YYYY');

  const potentialYear = moment(date, ['YYYY'], true);
  if (potentialYear.isValid()) return potentialYear.format('YYYY');

  return '';
};

export const formatISODate = (date, formatTo) => {
  if (!date) return '';
  const potentialDate = moment(date, [moment.ISO_8601], 'nl', true);

  return potentialDate.isValid()
    ? potentialDate.format(formatTo || 'DD-MM-YYYY')
    : '';
};

export const settingsDateFormatter = (date) =>
  formatISODate(date, 'D MMM YYYY HH:mm');

export const formatDateForBackend = (date) => {
  if (!date) return '';
  const potentialDate = moment(date, ['DD-MM-YYYY', 'D-M-YYYY'], true);

  return potentialDate.isValid() ? potentialDate.format('YYYY-MM-DD') : date;
};

export const checkAndFormatDates = (state, toBackend, dateKey = 'date') => {
  if (Array.isArray(state)) {
    return state.map((v) => checkAndFormatDates(v, toBackend, dateKey));
  } else if (state instanceof Object) {
    return Object.entries(state).reduce((mem, [key, value]) => {
      if (key.toLowerCase().includes(dateKey)) {
        mem[key] = toBackend ? formatDateForBackend(value) : formatDate(value);
      } else if (Array.isArray(value)) {
        mem[key] = value.map((v) => checkAndFormatDates(v, toBackend, dateKey));
      } else if (value instanceof Object) {
        mem[key] = checkAndFormatDates(value, toBackend, dateKey);
      } else {
        mem[key] = value;
      }
      return mem;
    }, {});
  }
  return state;
};

export const appointmentDateFormat = 'YYYY-MM-DD HH:mm';

export const formatAppointmentDate = date => {
  const { language } = getI18n();
  const fullDate = moment(date, [moment.ISO_8601, appointmentDateFormat], language || 'nl', true);

  if (fullDate.isValid()) {
    return ({
      day: fullDate.format('dddd D MMMM'),
      date: fullDate.format('YYYY-MM-DD'),
      time: fullDate.format('HH:mm'),
      dateTime: fullDate.format(appointmentDateFormat),
      fullDate: fullDate
    })
  }
  return {fullDate}
};

export const getReadableDuration = (start, end) => {
  const duration = moment.duration(end.diff(start));

  if (duration.asMinutes() >= 1 && duration.asMinutes() <= 59) {
    return `${duration.asMinutes()} minuten`;
  } else if (duration.asMinutes() >= 60) {
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    if (minutes === 0) {
      return `${hours} uur`;
    } else {
      return `${hours} uur en ${minutes} minuten`;
    }
  } else {
    return duration.asMinutes(); // Handle invalid cases
  }
}